import React, { FC } from 'react';
import classNames from 'classnames';

import Figures from './Figure/Figure';

import { containerStyles, flexStyles } from './styles.css';
import { PlayerColor } from '../../../types';

type FigureGroupProps = {
  name: string;
  color: PlayerColor;
  count: number;
  reverse?: boolean;
  setName?: string;
};

const FigureGroup: FC<FigureGroupProps> = ({ name, color, count, reverse, setName }) => (
  <div className={classNames(containerStyles, flexStyles[reverse ? 'reverse' : 'default'])}>
    {new Array(count).fill(null).map((_, index) => (
      <Figures name={name} color={color} key={`${index}${name}`} setName={setName} reverse={reverse} />
    ))}
  </div>
);

export default FigureGroup;
